import React, { useId } from "react";
import styled from "styled-components";
import { premiumTheme as theme } from "./premiumTheme";

const Field = styled.div`
    min-width: 0; font-family: ${theme.fontFamily}; font-weight: 400;
    .warehouse-label { display: block; margin: 0 0 6px; color: ${theme.panelMuted}; font-size: 12px; line-height: 18px; }
    .warehouse-trigger { box-sizing: border-box; width: 100%; min-width: 0; height: 42px; padding: 0 12px;
        display: flex; align-items: center; justify-content: space-between; gap: 10px;
        background: ${theme.blockedBackground}; border: 1px solid ${theme.fieldBorder}; border-radius: 10px;
        color: ${theme.placeholder}; font: 400 13px/18px ${theme.fontFamily}; text-align: left; cursor: not-allowed; }
    .warehouse-value { min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-style: italic; }
    .warehouse-chevron { width: 14px; height: 14px; flex: 0 0 14px; color: ${theme.panelMuted}; }
`;

/**
 * Approved v13 first release: visible, disabled destination-warehouse placeholder only.
 * No options, selection, listeners, requests, persistence or CHECK/export wiring.
 * Warehouse selection will be implemented under a separate task.
 */
export default function PremiumWarehouseSelector({ label = "Destination warehouse", placeholder = "Select warehouse", className }) {
    const id = useId();
    return <Field className={className}>
        <label className="warehouse-label" id={`${id}-label`} htmlFor={`${id}-trigger`}>{label.replace(/:\s*$/, "")}:</label>
        <button type="button" id={`${id}-trigger`} className="warehouse-trigger" disabled aria-disabled="true"
            aria-labelledby={`${id}-label ${id}-value`} aria-haspopup="listbox" aria-expanded="false">
            <span id={`${id}-value`} className="warehouse-value" title={placeholder}>{placeholder}</span>
            <svg className="warehouse-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="m3 6 5 5 5-5" /></svg>
        </button>
    </Field>;
}
